import { EziDebitProviderUiBehaviour } from './ezidebit/provider-ui-behaviour';

export type PaymentContact = {
	firstName?: string;
	lastName?: string;
	name?: string;
	email?: string;
};

export type PaymentProviderUiBehaviour = {
	resolveContact?: (formContact: PaymentContact, target?: PaymentContact) => PaymentContact;
	buildExtraSettings?: (contact: PaymentContact & { companyName?: string }) => Record<string, unknown>;
	supportsPricingSchedule?: boolean;
};

export const PaymentProviderUiBehaviours: Record<string, PaymentProviderUiBehaviour | undefined> = {
	EziDebit: EziDebitProviderUiBehaviour
};
